import { render } from "./EditOffrePage.vue?vue&type=template&id=4aa1cf5b&ts=true"
import script from "./EditOffrePage.vue?vue&type=script&lang=ts"
export * from "./EditOffrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__